<af-main-container [title]="(dashboardId ? 'i18n_af_dashboardFormTitleEdit' : 'i18n_af_dashboardFormTitleCreate') | translate"
                   [tabPathToTab]="tabPathToTab"
                   [spinnerIds]="dashboardId && initialSpinner">
    <div CustomButtons fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
        <ui-kit-button type="secondary"
                       buttonType="button"
                       [fitContent]="true"
                       (clickListener)="navigateBack()"
                       [label]="'i18n_af_buttonCancel' | translate"/>
        <ui-kit-button buttonType="button"
                       [fitContent]="true"
                       [spinnerId]="submitSpinner"
                       [disabled]="form.invalid"
                       (clickListener)="submit()"
                       [label]="'i18n_af_buttonSave' | translate"/>
    </div>

    @if (!dashboardId || dashboard) {
        <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
            <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start">
                <div class="grid-form-container">
                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_dashboardFormLabelName' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.value.name">
                            <input matInput
                                   formControlName="name"
                                   name="name"
                                   [maxlength]="maxNameLength"
                                   [placeholder]="'i18n_af_dashboardFormPlaceholderName' | translate"/>
                            @if (form.controls.name.hasError('required')) {
                                <mat-error class="c-secondary-red-900">{{ 'i18n_af_fieldValidationRequired' | translate }}</mat-error>
                            }
                            @if (form.controls.name.hasError('maxlength')) {
                                <mat-error class="c-secondary-red-900">{{ 'i18n_af_maxlengthError' | translate }}</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_dashboardFormLabelDashboardId' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.controls.dashboardId.valid">
                            <input matInput
                                   formControlName="dashboardId"
                                   name="dashboardId"
                                   [placeholder]="'i18n_af_dashboardFormPlaceholderDashboardId' | translate"/>
                            @if (form.controls.dashboardId.hasError('required')) {
                                <mat-error class="c-secondary-red-900">{{ 'i18n_af_fieldValidationRequired' | translate }}</mat-error>
                            }
                            @if (form.controls.dashboardId.hasError('pattern')) {
                                <mat-error class="c-secondary-red-900">{{ 'i18n_af_dashboardFormErrorDashboardIdFormat' | translate }}</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <af-dictionary-selector dictionaryName="composite_roles"
                                            [control]="form.controls.roles"
                                            [isMultiple]="true"
                                            [showCode]="true"
                                            [predefinedValue]="dashboard?.roles"
                                            label="i18n_af_dashboardFormLabelRoles"
                                            placeholder="i18n_af_dashboardFormPlaceholderRoles"
                                            selectedCountPlaceholder="i18n_af_placeholderRolesSelectedCount"/>

                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_dashboardFormLabelFilters' | translate }}</div>
                        <mat-form-field class="w-100 mt-4" [class.value-not-empty]="form.value.filters?.length">
                            <mat-select formControlName="filters"
                                        multiple
                                        class="h-100"
                                        fxLayoutAlign="start center"
                                        panelClass="hide-scroll-bar"
                                        [placeholder]="'i18n_af_dashboardFormPlaceholderFilters' | translate">
                                @for (filter of availableFilters; track filter) {
                                    <mat-option [value]="filter">{{ 'i18n_af_dashboardFilter#' + filter | translate }}</mat-option>
                                }
                            </mat-select>
                            <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                        </mat-form-field>
                    </div>

                    <ng-container formGroupName="filterDatasets">
                        @for (filter of selectedFilters; track filter) {
                            <div fxLayout="column" fxLayoutAlign="start start">
                                <div class="t5 c-primary-gray-600">
                                    {{ 'i18n_af_dashboardFormLabelFilterDatasets' | translate:
                                        {filter: 'i18n_af_dashboardFilter#' + filter | translate} }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.controls.filterDatasets.get(filter)?.value">
                                    <input matInput
                                           [formControlName]="filter"
                                           [placeholder]="'i18n_af_dashboardFormPlaceholderFilterDatasets' | translate"/>
                                    @if (form.controls.filterDatasets.get(filter)?.hasError('pattern')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_dashboardFormErrorFilterDatasets' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="t6 c-primary-gray-600">{{ 'i18n_af_dashboardFormHintFilterDatasets' | translate }}</div>
                                @if (restrictiveFilters.includes(filter)) {
                                    <div class="t6 c-secondary-red-900">
                                        {{ 'i18n_af_dashboardFormHintFilterDatasetsRestrictive' | translate }}
                                    </div>
                                }
                            </div>
                        }
                    </ng-container>
                </div>
            </form>
        </div>
    }
</af-main-container>
